import { useState } from "react";
import { useDispatch } from "react-redux";
import useFunctionIds from "../../../abstract/hook/useFunctionIds";
import { handleFunctionCreate } from "../../../abstract/redux/slice/structureSlice";
import IconBxsDownArrow from "../../../themes/icons/IconBxsDownArrow";
import IconBxsRightArrow from "../../../themes/icons/IconBxsRightArrow";
import IconPlusCircled from "../../../themes/icons/IconPlusCircled";
import { ButtonDefault } from "../../ui/buttons/ButtonDefault";
import FunctionPanel from "../function/FunctionPanel";
import FunctionStructure from "../function/structure/FunctionStructure";
import styles from "./AsideElementFunction.module.scss";

function AsideElementFunction() {
  const _idsFunction = useFunctionIds();

  const [_showFunctions, _setShowFunctions] = useState(false);

  const handleOnClick = () => {
    _setShowFunctions((e) => !e);
  };

  return (
    <div className={styles["function"]} id="group_function">
      <div className={styles["function__header"]} role="button" onClick={handleOnClick}>
        <span className={styles["function__container__icon"]}>
          {_showFunctions ? <IconBxsDownArrow /> : <IconBxsRightArrow />}
        </span>
        &nbsp;&nbsp;
        <span className={styles["function__container__header"]}>Functions</span>
      </div>

      {_showFunctions && (
        <div className={styles["function__container__content"]}>
          <div className={styles["function__container__list"]}>
            <ul>
              {_idsFunction?.map((e) => (
                <FunctionStructure key={e} id={e} />
              ))}
              <FunctionPanel />
            </ul>
            <AsideFunctionAdd />
          </div>
        </div>
      )}
    </div>
  );
}

const AsideFunctionAdd = () => {
  const dispatch = useDispatch();
  const [showButton, setShowButton] = useState(false);

  const handleMouseEnter = () => {
    setShowButton(true);
  };

  const handleMouseLeave = () => {
    setShowButton(false);
  };

  const handleAddFunction = () => {
    setTimeout(async () => {
      dispatch(handleFunctionCreate());
    }, 500);
  };

  return (
    <div
      className={styles["function__add"]}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}>
      {showButton ? (
        <ButtonDefault text="add function" handler={handleAddFunction} shadow={false} wide />
      ) : (
        <div className={styles["function__icon"]}>
          <IconPlusCircled />
        </div>
      )}
    </div>
  );
};

export default AsideElementFunction;
